import { render, staticRenderFns } from "./SchoolAwayTableControl.vue?vue&type=template&id=538400ab&scoped=true&"
import script from "./SchoolAwayTableControl.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538400ab",
  null
  
)

export default component.exports